import api, { publicRequest } from "../../../../BasicComponent/Service/api";
import {
  writeParamsUrl,
  proceduresUrl,
  procedureByUuidUrl,
  PUBLISH_URL,
  logsUrl,
  EXECUTION_START_URL,
  executionPauseUrl,
  executionResumeUrl,
  executionStopUrl,
  executionStatusUrl,
  activeExecutionUrl,
  lockAcquireUrl,
  lockHeartbeatUrl,
  lockReleaseUrl,
  lockStatusUrl,
  sessionAcceptUrl,
  sessionRejectUrl,
  sessionHeartbeatUrl,
  sessionForceUrl,
} from "../../../utils/writecontrolconst";

// ── Writable parameters ───────────────────────────────────────────────────────
export const getWriteParameters  = (assetUuid)        => api.get(writeParamsUrl(assetUuid));
export const saveWriteParameters = (assetUuid, params) => api.post(writeParamsUrl(assetUuid), params);

// ── Procedures ────────────────────────────────────────────────────────────────
export const getProcedures      = (assetUuid)   => api.get(proceduresUrl(assetUuid));
export const getProcedureByUuid = (uuid)         => api.get(procedureByUuidUrl(uuid));
export const createProcedure    = (data)         => api.post(proceduresUrl(data.assetUuid), data);
export const updateProcedure    = (uuid, data)   => api.put(procedureByUuidUrl(uuid), data);
export const deleteProcedure    = (uuid)         => api.delete(procedureByUuidUrl(uuid));

// ── Publish (manual write) ────────────────────────────────────────────────────
export const publishWrite = (data) => api.post(PUBLISH_URL, data);

// ── Audit logs ────────────────────────────────────────────────────────────────
export const getWriteLogs = (assetUuid, params = {}) =>
  api.get(logsUrl(assetUuid), { params });

// ── Execution (backend-driven procedure execution) ────────────────────────────
export const startExecution  = (body)  => api.post(EXECUTION_START_URL, body);
export const pauseExecution  = (uuid)  => api.post(executionPauseUrl(uuid));
export const resumeExecution = (uuid)  => api.post(executionResumeUrl(uuid));
export const stopExecution   = (uuid)  => api.post(executionStopUrl(uuid));
export const getExecution    = (uuid)  => api.get(executionStatusUrl(uuid));
export const getActiveExecution = (assetUuid) => api.get(activeExecutionUrl(assetUuid));

// ── Lock ──────────────────────────────────────────────────────────────────────
export const acquireLock   = (assetUuid) => api.post(lockAcquireUrl(assetUuid));
export const lockHeartbeat = (assetUuid) => api.post(lockHeartbeatUrl(assetUuid));
export const releaseLock   = (assetUuid) => api.post(lockReleaseUrl(assetUuid));
export const getLockStatus = (assetUuid) => api.get(lockStatusUrl(assetUuid));

// ── Session ───────────────────────────────────────────────────────────────────
export const acceptSession    = (sid) => api.post(sessionAcceptUrl(sid));
export const rejectSession    = (sid) => api.post(sessionRejectUrl(sid));
export const sessionHeartbeat = (sid) => api.post(sessionHeartbeatUrl(sid));
// export const forceSession     = (sid) => api.post(sessionForceUrl(sid));
export const forceSession = (sid) => publicRequest("post", sessionForceUrl(sid));